const schedule = {
  formId: "schedule-form",
  formField: {
    schedules: {
      name: "schedules",
      label: "Schedules",
      type: "selectWithDetails",
      placeholder: "",
      errorMsg: "",
      options: []
    },
    notes: {
      name: "notes",
      label: "Notes",
      type: "text",
      placeholder: "",
      errorMsg: ""
    }
  }
};

export default schedule;
